import { Text, TextAlignment, TokenTextAppearance, TextTag } from '@volkswagen-onehub/components-core';
import { Province } from '@vw-marketing/vw-ca-types';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { DisclaimerMarker } from '../../../components/DisclaimerMarker';
import { getTranslations } from '../../../translations';
import { UserLocationContext } from '../../../UserLocation/UserLocationContext';
import { getDisclaimerNumber } from '../../../utils/get-disclaimer-number';

const PriceDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
`;

type PriceDetailsProps = {
  isColor?: boolean;
  colorLabel?: string;
  color?: string | null;
  name?: string;
  price?: string;
  bold?: boolean;
  disclaimer?: string;
}

const PriceDetails = (props: PriceDetailsProps) => {
  const { disclaimers } = getTranslations();
  const { province } = useContext(UserLocationContext);

  const getDisclaimerText = (key: string, prov: Province) => {
    if (typeof disclaimers[key] === "string") {
      return disclaimers[key];
    } else if (typeof disclaimers[key] === "object") {
      return disclaimers[key].hasOwnProperty(province) ? disclaimers[key][prov] : disclaimers[key].CA;
    }
    return "";
  };

  return province ? (
    <PriceDetailsContainer>
      {
        !props.isColor
        ? <Text
          tag={TextTag.p}
          bold={props.bold !== false}
          appearance={TokenTextAppearance.copy200}
          textAlign={TextAlignment.start}
        >
          { props.name }
          { props.disclaimer && disclaimers[props.disclaimer] ? <DisclaimerMarker marker={getDisclaimerNumber(props.disclaimer) || ""} id={props.name as string} text={getDisclaimerText(props.disclaimer, province)}/> : null }
        </Text>
        : <Text
          tag={TextTag.p}
          bold
          appearance={TokenTextAppearance.copy200}
          textAlign={TextAlignment.start}
        >
          {props.colorLabel}:{" "}
          <Text
            bold={false}
            tag={TextTag.span}
          >
            {props.color}
          </Text>
        </Text>
      }
      {
        props.price
        ? <Text
            tag={TextTag.p}
            appearance={TokenTextAppearance.copy200}
            textAlign={TextAlignment.end}
          >
            {props.price}
          </Text>
        : null
      }
    </PriceDetailsContainer>
  )
  : null;
}

export default PriceDetails;
